<template>
  <div>
    <Header>
      Dodawanie kontaktu
    </Header>

    <b-row>
      <b-col xl="6">
        <Errors/>

        <b-form @submit.prevent="submit">
          <b-form-group label="Nazwa:">
            <b-input v-model="form.name" required/>
          </b-form-group>
          <b-form-group label="Telefon:">
            <b-input v-model="form.phoneNumber" :state="isPhoneValid" :formatter="phoneFormatter" type="tel" required/>
          </b-form-group>
          <b-form-group label="Email:">
            <b-input v-model="form.email" type="email" :state="isEmailValid"/>
          </b-form-group>
          <b-form-group>
            <div class="d-flex justify-content-between">
              <div>
                <inertia-link
                  :href="route('contacts.index')"
                  as="b-button"
                  variant="secondary"
                >
                  <b-icon icon="x"/>
                  Anuluj
                </inertia-link>
              </div>
              <div>
                <b-button type="submit" variant="primary" :disabled="form.processing">
                  <b-icon icon="plus"/>
                  Dodaj
                </b-button>
              </div>
            </div>
          </b-form-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Layout from '@/Layouts/Default'
import Header from '@/Layouts/Components/Header'
import Errors from '@/Layouts/Components/Errors'
import EmailValidation from '@/Mixins/EmailValidation'
import _ from "lodash";

export default {
  components: {
    Header,
    Errors,
  },
  layout: Layout,
  mixins: [EmailValidation],
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        phoneNumber: '',
        email: '',
      }),
    }
  },
  computed: {
    isPhoneValid() {
      const phone = this.form.phoneNumber.replace(/ /g, '')
      return phone.length === 9
    },
    isEmailValid() {
      return this.validateEmail(this.form.email);
    },
  },
  methods: {
    submit() {
      this.form
        .transform((data) => {
          data.phoneNumber = data.phoneNumber.replace(/ /g, '')
          return data
        })
        .post(this.route('contacts.store'))
    },
    phoneFormatter(val) {
      val = val.replace(/\D/g, '')
      if (val.startsWith('48') && val.length === 11) {
        val = val.replace('48', '')
      }
      val = val.match(/.{1,3}/g) || []
      return val.join(' ')
    },
  },
}
</script>
